import React from 'react';
import { flowRight as compose } from 'lodash';

import staticPageStyles from '../StaticPages/StaticPage.module.scss';
import { withSEO } from '../SEO/withSEO';

class ImprintScreen extends React.Component {
  static defaultProps = {
    meData: null,
    userItestResults: null,
  };

  render() {
    return (
      <div className={staticPageStyles.staticPage} data-nosnippet>
        <div className={staticPageStyles.card}>
          <div className={staticPageStyles.cardHeader}>
            <h1>IMPRESSUM</h1>
          </div>
          <div className={staticPageStyles.cardContent}>
            <p>
              <h2>AK Wien</h2>
              Prinz-Eugen-Straße 20-22
              <br />
              1040 Wien
            </p>
            <p>
              <h2>AK Oberösterreich</h2>
              Volksgartenstraße 40
              <br />
              4020 Linz
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withSEO({
    title: 'Jopsy | Impressum',
    description:
      'AK Wien, Prinz-Eugen-Straße 20-22, 1040 Wien | AK Oberösterreich, Volksgartenstraße 40, 4020 Linz',
  }),
)(ImprintScreen);
